import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { HashRouter, Routes, Route } from "react-router-dom";
import { MotionConfig } from "framer-motion";
import { ROUTE_PATHS } from "@/lib/index";
import Home from "@/pages/Home";
import MemberLogin from "@/pages/MemberLogin";
import MemberDashboard from "@/pages/MemberDashboard";
import MemberZone from "@/pages/MemberZone";
import AnnouncementPage from "@/pages/AnnouncementPage";
import OrgChart from "@/pages/OrgChart";

const queryClient = new QueryClient();

const App = () => (
  <QueryClientProvider client={queryClient}>
    <TooltipProvider>
      <MotionConfig reducedMotion="user">
        <Toaster />
        <Sonner />
        <HashRouter>
          <Routes>
            <Route path={ROUTE_PATHS.HOME} element={<Home />} />
            <Route path={ROUTE_PATHS.MEMBER_LOGIN} element={<MemberLogin />} />
            <Route path={ROUTE_PATHS.MEMBER_DASHBOARD} element={<MemberDashboard />} />
            <Route path={ROUTE_PATHS.MEMBER_ZONE} element={<MemberZone />} />
            <Route path={ROUTE_PATHS.ANNOUNCEMENT} element={<AnnouncementPage />} />
            <Route path={ROUTE_PATHS.ORG_CHART} element={<OrgChart />} />
          </Routes>
        </HashRouter>
      </MotionConfig>
    </TooltipProvider>
  </QueryClientProvider>
);

export default App;
